// tslint:disable:no-var-requires no-require-imports
export const auto: string = require("../../../../assets/images/auto.png");
export const user: string = require("../../../../assets/images/user.png");
